export default __webpack_public_path__ + "static/media/enzyme-activity-diagram-USA.1103454c.png";